module.exports = __webpack_public_path__ + "img/askmebet-support.b47f7174.png";